// TODO organize everything as the schema which you can see here: https://vuex.vuejs.org/guide/structure.html
const moduleHomePage = {
  namespaced: true,
  state: () => ({
    activeSlide: 0,
    hasProgressBar: true,
    prevActive: 0,
    slides: [
      {
        alternativeText: 'wood wallpaper',
        details: '',
        showDetails: false,
        subtitle: 'Azienda Agricola',
        text: 'Coop AG. AR. TUR. 2013',
        title: 'SITIZZO',
      },
      {
        alternativeText: 'eggs',
        details: 'Mettiamo amore e semplicità in ciò che facciamo, restiamo in armonia con la natura rispettando i suoi tempi. Realizziamo prodotti sani e genuini.',
        showDetails: false,
        subtitle: '',
        text: '',
        title: 'Autentici',
      },
      {
        alternativeText: 'horse riding',
        details: 'Tutte le nostre attività sostengono uno stile di vita consapevole e a favore non solo del nostro benessere, ma anche della comunità e del pianeta.',
        showDetails: false,
        subtitle: '',
        text: '',
        title: 'Sostenibili',
      },
      {
        alternativeText: 'heart on wood',
        details: 'Abbiamo adottato una forma comunitaria di scambio e crescita, con progetti mirati all\'integrazione. Crediamo nei valori del confronto e della partecipazione.',
        showDetails: false,
        subtitle: '',
        text: '',
        title: 'Solidali',
      },
    ],
  }),
  mutations: {
    next (state) {
      if(state.activeSlide < state.slides.length - 1){
        state.prevActive = state.activeSlide
        state.activeSlide++
      }
    },
    prev (state) {
      if(state.activeSlide > 0){
        state.prevActive = state.activeSlide
        state.activeSlide--
      }
    },
    showDetails (state) {
      state.slides[state.activeSlide].showDetails = true
    },
    setActiveSlide (state, value) {
      state.activeSlide = value
    },
  }
}

const moduleSlide = {
  namespaced: true,
  state: () => ({
    clickToNext: true,
    progress: 0,
    totalSteps: 0,
  }),
  mutations: {
    decrement (state) {
      if(state.progress > 0){
        state.progress--
        state.clickToNext = state.progress === 0
      }
    },
    increment (state) {
      if(state.progress < state.totalSteps){
        state.progress++
        state.clickToNext = state.progress < state.totalSteps
      }
    },
    reset (state, newTotalSteps) {
      state.clickToNext = true
      state.progress = 0
      state.totalSteps = newTotalSteps || 0
    },
    setProgress (state, progress) {
      state.progress = progress
    }
  }
}

export default {
  modules: {
    homePage: moduleHomePage,
    slide: moduleSlide
  }
}
